import React from "react";
import { FaArrowLeft, FaFileAlt, FaDownload } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";
import ExportExcel from "../../Components/Utils/ExportExcel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import trLocale from "date-fns/locale/tr";
import { PageShell, AppLink } from "../../Components/shared";

const ReportLayout = ({
  title,
  excelData,
  fileName,
  children,
  excelConfig = null,
  showBackButton = true,
  showExcel = true,
  headerActions = null,
  // PDF üreten raporlar için iki sütunlu yerleşim: filtreler SOLDA dar bir
  // kolonda dikey akar, rapor (PDF önizleme) SAĞDA geniş alanı kaplar.
  // Verilmezse eski tek sütunlu düzen aynen sürer (tablo raporları).
  sidebar = null,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={trLocale}>
      <PageShell>
        {/* Sticky Header */}
        <div className="sticky top-0 z-10 bg-white border-b border-gray-100 shrink-0 px-3 sm:px-4 py-2.5">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2.5 min-w-0">
              {showBackButton && (
                <AppLink
                  to="/Anasayfa/Rapor/Menu"
                  aria-label="Rapor menüsüne dön"
                  className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors shrink-0"
                >
                  <FaArrowLeft className="w-3.5 h-3.5" />
                </AppLink>
              )}
              <div className="p-1.5 sm:p-2 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg sm:rounded-xl shadow-sm border border-blue-100 shrink-0">
                <FaFileAlt className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />
              </div>
              <div className="min-w-0">
                <h2 className="text-sm sm:text-base font-bold text-gray-800 leading-tight truncate">{title}</h2>
                <p className="text-[10px] sm:text-xs text-gray-500 hidden sm:block">Rapor detayları ve analiz</p>
              </div>
            </div>

            <div className="flex items-center gap-2 shrink-0">
              {/* PDF çıktısı veren raporlarda Excel butonu anlamsız —
                  showExcel={false} ile kapatılıp headerActions ile kendi
                  indirme butonunu koyar (bkz. Müşteri Aylık Performans Raporu). */}
              {headerActions}
              {showExcel && (
                /* Mobilde sadece indirme ikonu, sm+ ekranda ikon + "Excel İndir" */
                <ExportExcel
                  excelData={excelData}
                  fileName={fileName}
                  {...excelConfig}
                  renderTrigger={(exportToExcel) => (
                    <button
                      onClick={exportToExcel}
                      title="Excel İndir"
                      className="flex items-center gap-1.5 px-2.5 py-2 sm:px-3.5 bg-blue-600 text-white rounded-lg shadow-sm hover:bg-blue-700 active:bg-blue-800 transition-colors text-xs font-semibold"
                    >
                      <RiFileExcel2Fill className="w-4 h-4" />
                      <FaDownload className="w-3 h-3" />
                      <span className="hidden sm:inline">Excel İndir</span>
                    </button>
                  )}
                />
              )}
            </div>
          </div>
        </div>

        {/* İçerik — sayfa scroll etmez: filtre/buton alanı sabit kalır,
            yalnızca içeriğin kendisi kaydırılır. */}
        {sidebar ? (
          /* İki sütun: solda filtreler (dar, kendi içinde kayar), sağda rapor.
             Dar ekranda alt alta düşer — filtreler üstte kalır. */
          <div className="flex-1 min-h-0 px-3 sm:px-4 py-2 sm:py-4 grid grid-cols-1 lg:grid-cols-[320px_minmax(0,1fr)] xl:grid-cols-[360px_minmax(0,1fr)] gap-3 sm:gap-4 overflow-hidden">
            <div className="min-h-0 overflow-y-auto lg:pr-1">{sidebar}</div>
            <div className="min-h-0 flex flex-col gap-2 sm:gap-4 overflow-hidden">
              {children}
            </div>
          </div>
        ) : (
          <div className="flex-1 min-h-0 px-3 sm:px-4 py-2 sm:py-4 flex flex-col gap-2 sm:gap-4 overflow-hidden">
            {children}
          </div>
        )}
      </PageShell>
    </LocalizationProvider>
  );
};

export default ReportLayout;
